import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useRef, useState } from 'react'
import { secToHourMinute } from '../../../utils/date'
import Tips from '../common/Tips'

interface Props {
  displayCount?: number
  scheduledTime: number
  changeCallback: (value: number) => void
  editable: boolean
}

const DetailCostInputArea: FC<Props> = (props) => {
  const {
    displayCount,
    scheduledTime,
    changeCallback,
    editable,
  } = props

  const [isDisplayScheduledTime, setIsDisplayScheduledTime] = useState<boolean>(false)

  const [inputScheduledTime, setInputScheduledTime] = useState<string>("")

  const scheduledTimeRef = useRef<HTMLInputElement>(null)

  const formatNumber = (value: string) => (
    Number(value.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0)).replace(/[^0-9]/g, ''))
  )

  const formatScheduledTimeValue = () => {
    let tmpVal
    if (inputScheduledTime.indexOf(":") >= 0) {
      const tmpList = inputScheduledTime.split(":").map((v) => formatNumber(v))
      if (tmpList[1] >= 60) {
        tmpList[1] = 0
      }
      tmpVal = (tmpList[0] * 3600) + (tmpList[1] * 60)
      if (tmpList[1]) {
        setInputScheduledTime(`${tmpList[0]}:${(`00${tmpList[1].toString()}`).slice(-2)}`)
      } else {
        setInputScheduledTime(tmpList[0].toString())
      }
    } else {
      tmpVal = formatNumber(inputScheduledTime) * 3600
      setInputScheduledTime(tmpVal ? (tmpVal / 3600).toString() : "")
    }
    setIsDisplayScheduledTime(false)
    changeCallback(tmpVal)
  }

  useEffect(() => {
    if (!isDisplayScheduledTime) return
    scheduledTimeRef.current?.focus()
  }, [isDisplayScheduledTime])

  useEffect(() => {
    if (scheduledTime % 3600) {
      setInputScheduledTime(`${secToHourMinute(scheduledTime)}`)
    } else {
      setInputScheduledTime(scheduledTime ? Math.floor(scheduledTime / 3600).toString() : "")
    }
  }, [])

  return (
    <>
      <div
        style={{
          width: displayCount ? `calc((100% / ${displayCount}) - 8px)` : "100%",
          padding: "8px",
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
          fontSize: "14px",
          maxWidth: displayCount ? "160px" : "none",
          position: "relative",
          minWidth: "140px",
        }}
      >
        {
          editable ? (
            <>
              {
                isDisplayScheduledTime ? (
                  <input
                    type="text"
                    ref={scheduledTimeRef}
                    style={{ width: "100%", textAlign: "right" }}
                    onChange={(e) => setInputScheduledTime(e.target.value)}
                    onBlur={() => formatScheduledTimeValue()}
                    onKeyPress={(e) => e.key === "Enter" && formatScheduledTimeValue()}
                    value={inputScheduledTime}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      border: "solid 1px #4572ba",
                      padding: "6px 8px",
                      textAlign: "right",
                      borderRadius: "4px",
                      color: "#4572ba",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      backgroundColor: "#FFFFFF",
                    }}
                    onClick={() => setIsDisplayScheduledTime(true)}
                    role="none"
                  >
                    <FontAwesomeIcon
                      icon={['fas', 'pen']}
                    />
                    {inputScheduledTime || "予定時間なし"}
                  </div>
                )
              }
            </>
          ) : (
            <div
              style={{
                width: "100%",
                backgroundColor: "#ffffff",
                padding: "6px 8px",
                textAlign: "right",
                color: "#4572ba",
                fontWeight: "bold",
                borderBottom: "solid 1px #4572ba",
              }}
            >
              {inputScheduledTime ? `${inputScheduledTime}時間` : "予定時間なし"}
            </div>
          )
        }
      </div>
    </>
  )
}
DetailCostInputArea.defaultProps = {
  displayCount: undefined,
}

export default DetailCostInputArea
